import { useEffect } from 'react';
import { TrackingCategory, TrackingType } from '@tn/foundation/entities/tracking/const';
import {
    BootstrapSignalKeys,
    BootstrapSignals,
} from '@tn/foundation/entities/tracking/lib/bootstrap-signals';
import { getPageType } from '@tn/foundation/entities/tracking/stores/pageTypeStore';
import useTrackEvent from '@tn/foundation/hooks/tracking/useTrackEvent';

/**
 * bfcache restore fires `pageshow` but skips the navigation/bootstrap lifecycle (no remount,
 * no `useTrackLaunchReady`) — `getPageType()` is safe since the page is frozen as the user left it.
 */
export function useTrackBfcacheRestore(): void {
    const trackEvent = useTrackEvent();

    useEffect(() => {
        const handlePageShow = (event: PageTransitionEvent) => {
            if (!event.persisted) return;

            // bfcache restore skips the routeChangeComplete rebuild that normally re-marks
            // INFO_UPDATE, so mark it here directly — the frozen snapshot is still valid.
            BootstrapSignals.mark(BootstrapSignalKeys.INFO_UPDATE);

            trackEvent({
                type: TrackingType.PAGE_VIEW,
                category: TrackingCategory.App.VIEW,
                detail: {
                    context: {
                        pageType: getPageType(),
                    },
                },
            });
        };

        window.addEventListener('pageshow', handlePageShow);
        return () => window.removeEventListener('pageshow', handlePageShow);
    }, [trackEvent]);
}
